import React, { Suspense, useMemo } from 'react';
import HandsModel from './model';
import { Canvas } from '@react-three/fiber';
import { NFTHandColors } from 'shared';
import { toHandColor } from '../../../../../../utils/color';
import { IUseGlbAnimations } from './useGlbAnimations';
import { HandSize } from './Interfaces';

interface Props {
  leftColor: NFTHandColors;
  rightColor: NFTHandColors;
  leftAnimator: IUseGlbAnimations;
  rightAnimator: IUseGlbAnimations;
  size?: HandSize;
}

type Colors = {
  left: string;
  right: string;
};

//position: [left-right, top-bottom, front-back]

const BattleActionHands = ({
  leftColor,
  rightColor,
  leftAnimator,
  rightAnimator,
  size,
}: Props) => {
  const colors = useMemo<Colors>(() => {
    return {
      left: toHandColor(leftColor),
      right: toHandColor(rightColor),
    };
  }, [leftColor, rightColor]);

  return (
    <Canvas
      style={{
        background: 'transparent',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 3,
      }}
      camera={{
        fov: 40,
        far: 10000,
        position: [0, 1.5, 10],
        rotation: [-Math.PI, Math.PI, -Math.PI],
      }}
    >
      <ambientLight intensity={0.4} />
      <spotLight
        intensity={0.8}
        position={[-8, 10, -5]}
        color='#f0e4cb'
        angle={0.4}
        penumbra={1}
        castShadow={true}
      />
      <spotLight
        intensity={0.4}
        angle={0.3}
        penumbra={1}
        position={[15, -10, 5]}
        castShadow={true}
        color='#FFF'
      />
      <Suspense fallback={null}>
        <HandsModel color={colors.left} animator={leftAnimator} size={size} />
        <HandsModel
          mirrored
          color={colors.right}
          animator={rightAnimator}
          size={size}
        />
      </Suspense>
    </Canvas>
  );
};

export default BattleActionHands;
